import api from "@/lib/api";

export default {
  getAll(module) {
    return api.get("/api/v1/shared/tag/select-all", {
      params: { any: module, currentPage: 1, totalPerPage: 2000 },
    });
  },
  create(module, model) {
    return api.post("/api/v1/shared/tag/create", { ...model, module });
  },
  updateTags(url, cardId, tags) {
    return api.put(url, { id: cardId, tags });
  },
};
